import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { RestDataService } from '../../service/rest-data.service';
import { Config } from '../../config/config';
import { FormControl } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from '../../service/shared-data.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-match-component',
  templateUrl: './match-component.component.html',
  styleUrls: ['./match-component.component.css']
})
export class MatchComponentComponent implements OnInit {

  @Output() sendPopupValueToParentfn = new EventEmitter<any>();
  @Output() sendMatchDetailsToParentfn = new EventEmitter<any>();
  searchQuery: FormControl = new FormControl();
  seriesList = [];
  matchList = [];
  matchDetails = {
    'matchId': null,
    'seriesId': null,
    'seriesName': null,
    'matchNameWithDate': null,
    'teamAShortName': null,
    'teamBShortName': null,
    'teamA':null,
    'teamAId':null,
    'teamB':null,
    'teamBId':null,
    'matchFile':null,
  };
  seriesInputQuery = '';
  @Input('seriesName') seriesName:any;
  @Input('matchId') matchId:any;
  matchInputQuery = '';
  cssBlock = '';
  noresults = false;
  constructor(private restService: RestDataService,
              private config: Config,
              private snotify: SnotifyService,
              private sharedService: SharedDataService) { }

  ngOnInit() {
    this.searchQuery.valueChanges
        .pipe(debounceTime(200)
        ,distinctUntilChanged())
        .subscribe(result => {
          this.searchResults(result, 0, data => {
            this.seriesList = [];
            if (data.length > 0) {
              this.seriesList = data;
              this.noresults = false;
            } else {
              this.noresults = true;
            }
          });
        });
        if(this.seriesName){
          this.seriesInputQuery = this.seriesName;
        }
  }

  getSeriesDetails() {
    this.matchList = [];
    const url = this.config.get('product').baseUrl
    + '/api/cms/element/cricket/fixtures?page=0&size=50'
    + '&sort=seriesStartDate,desc'
    + '&fields=matches.matchId,seriesId,seriesName,matches.teamAId,matches.teamA,'
    + 'matches.teamBId,matches.teamB,matches.teamAShortName,matches.teamBShortName,seriesStartDate,seriesEndDate,matches.matchName,matches.matchFile';
    this.restService.http_get(url)
      .subscribe(
        data => {
          this.seriesList = data;
        },
        err => {
          console.log(err);
        }
      );
  }
  searchResults(query1, pageNum, callback) {
    const query = query1;
      if (query) {
        let url = this.config.get('product').baseUrl
        + '/api/cms/element/cricket/fixtures?page=0&size=50'
        + '&sort=seriesStartDate,desc'
        + '&fields=matches.matchId,seriesId,seriesName,matches.teamAId,matches.teamA,'
        + 'matches.teamBId,matches.teamB,matches.teamAShortName,matches.teamBShortName,seriesStartDate,seriesEndDate,matches.matchName,matches.matchFile';
        url += '&search=seriesName:' + query.trim();
        this.restService.http_get(url)
          .subscribe(data => {
            this.seriesList = data;
            this.seriesList.forEach(e=>{
              if(this.seriesName && e.seriesName === this.seriesName){
                this.matchList = e.matches;
                this.matchDetails.seriesId = e.seriesId;
                this.matchDetails.seriesName = e.seriesName;
              }
            })
          },
            error => {
              console.log(error);
            });
      } else {
        this.getSeriesDetails();
      }
  }
  setMatchData(obj) {
    this.seriesName = ''
    this.seriesInputQuery = obj.seriesName;
    this.matchDetails.seriesId = obj.seriesId;
    this.matchDetails.seriesName = obj.seriesName;
    this.matchList = obj.matches;
    this.cssBlock = '';
  }
  getMatchDetails(obj) {
    this.matchDetails.matchId = obj.target.value;
    this.matchDetails.matchNameWithDate = obj.target.options[obj.target.selectedIndex].text;
    this.matchList.forEach(e=>{
      if(this.matchDetails.matchId === e.matchId){
       this.matchDetails.teamAShortName = e.teamAShortName;
       this.matchDetails.teamBShortName = e.teamBShortName;
       this.matchDetails.teamA = e.teamA,
       this.matchDetails.teamAId = e.teamAId,
       this.matchDetails.teamB = e.teamB,
       this.matchDetails.teamBId = e.teamBId,
       this.matchDetails.matchFile = e.matchFile
      }
    })
  }
  filterAutoCompleteKeyUp(event, type) {
     this.cssBlock = 'block';
  }
  filterAutoCompleteKeyDown(event, type) {

  }

  focusInSuggestion(model) {

  }
  closeMatchPopup() {
    this.sendPopupValueToParentfn.emit(false);
  }

  saveMatchDetails() {
    if (this.matchDetails.matchId !== null && this.matchDetails.seriesId !== null) {
      this.sendMatchDetailsToParentfn.emit(this.matchDetails);
      this.sendPopupValueToParentfn.emit(false);
      this.matchDetails.seriesId = null;
      this.matchDetails.seriesName = null;
      this.matchDetails.matchId = null;
      this.matchDetails.matchNameWithDate = null;
    } else {
      this.snotify.error('Please enter match details', '', this.sharedService.getConfig(false));
    }
  }
}
